import React, { useState, useCallback, useMemo } from 'react';
import './styles/Form.scss';

const Form = (props) => {
  const { handleSend,formState, setFormState, geolocaliser } = props;

  const handleChange = useCallback((e) => {
    
    const { name, value } = e.target;
    setFormState(name, value);
  }, [setFormState]);
    
  const isSendButtonDisabled = useMemo(() => {
    return !formState.address || formState.address.trim() === '';
  }, [formState.address]);

  const handleClickSend = useCallback((evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (isSendButtonDisabled) {
      console.log("L'adresse est vide, impossible d'envoyer.");
      return; 
    }
    console.log('handleClickSend', formState.address, formState.asked_date);
    handleSend();

    setFormState('');
    

  }, [handleSend]); 


  return (
    <form className="form-container">
      <div>Renseignez votre adresse ou géolocalisez vous</div>

      <div className='form-input'>
        <textarea
          type="text"
          id="myInput"
          name="address"
          value={formState.address}
          onChange={handleChange}
          placeholder="Renseignez une adresse manuellement"
        />
        <button type="button" onClick={() => geolocaliser(setFormState)}>
        Géolocalisation
      </button>
      </div>
      <div>Renseignez eventuellement la date souhaitée</div>
      <div>
        <input
          type="datetime-local"
          id="myInputDate"
          name="asked_date"
          value={formState.asked_date}
          onChange={handleChange}
        />
      </div>  
      <div> --------------------------------------------------------- </div>
      <button onClick={handleClickSend}
       className='sendButton'
        disabled={isSendButtonDisabled}
        style={{ backgroundColor: isSendButtonDisabled ? 'rgba(255, 255, 255, 0)' : '#FFFFFF' 
          , color: isSendButtonDisabled ? 'rgba(0, 0, 0, 0)' : 'rgb(0, 140, 255)',
          cursor: isSendButtonDisabled ? 'not-allowed' : 'pointer',
          boxShadow: isSendButtonDisabled ? 'none' : 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
          transition: 'all 0.2s ease-in-out',
        }}
        >Rechercher</button>
    </form>
  )
};

export default Form;